import { ErrorFactory } from '@js/errors/factory'
import get from 'lodash/get'

const expiredSignatureStr = 'expired signature'

export function parseError (error) {
  const additionalParams = {}

  if (error.repeatDetails) {
    additionalParams.repeatDetails = error.repeatDetails
  }

  let body
  const rawBody = error.response ? error.response.data : error.body
  try {
    body = JSON.parse(rawBody)
  } catch (e) {
    if (rawBody && rawBody.errors) {
      body = rawBody
    } else {
      return parseSingleError({ ...error, ...additionalParams })
    }
  }
  const errors = body.errors
  const parsedErrors = errors.map(error => parseSingleError({ ...error, ...additionalParams }))
  if (parsedErrors.lenght === 0 || parsedErrors[0].errorType === undefined) return errors[0]
  // TODO: need deal somehow with multiple errors:
  if (parsedErrors.length > 0) return parsedErrors[0]
}

function parseSingleError (error) {
  if (!error || (!error.status && !error.response)) return ErrorFactory.getServerError()
  const status = +error.status || +error.response.status
  switch (status) {
    case 400:
      return parseBadRequestError(error)
    case 403:
      return parseTfaError(error)
    case 502:
      return parseServerError(error)
    case 404:
      return parseNotFoundError(error)
    case 409:
      return parseConfictError()
    default:
      return ErrorFactory.getDefaultError(error)
  }
}

function parseTfaError (error) {
  const walletId = error.meta && error.meta.wallet_id
  const factorId = error.meta && error.meta.factor_id
  const token = error.meta && error.meta.token
  const keychainData = error.meta && error.meta.keychain_data
  const salt = error.meta && error.meta.salt
  const repeatDetails = error.repeatDetails
  const code = error.code || error.response.data.type
  if (keychainData) {
    return ErrorFactory.getPasswordFactorError(factorId, token, keychainData, salt, repeatDetails)
  } else if (factorId && token) {
    return ErrorFactory.getOtpError({factorId, token, repeatDetails, walletId})
  } else if (code === 'verification_required') {
    return ErrorFactory.getEmailNotVerifiedError()
  } else if (code === 'tfa_recovery') {
    return ErrorFactory.getTFARecoveryError({walletId})
  } else if (code === 'tfa_exceeded') {
    return ErrorFactory.getTFAExceededCodeError()
  } else return ErrorFactory.getDefaultError()
}

function parseServerError () {
  return ErrorFactory.getServerError()
}

function parseNotFoundError () {
  return ErrorFactory.getNotFoundError()
}

function parseConfictError () {
  return ErrorFactory.getConflictError()
}

function parseBadRequestError (error) {
  const { code, message } = getTransactionError(error)
  if (message) {
    return ErrorFactory.getTransactionError(message, code)
  }

  if (error.meta && error.meta.field === 'data/attributes/otp') {
    return ErrorFactory.getTFAWrongCodeError()
  } else if (get(error, 'body.extras.reason') === expiredSignatureStr) {
    return ErrorFactory.getExpiredSignatureError()
  } else {
    return ErrorFactory.getDefaultError()
  }
}

function getTransactionError (error) {
  let details = (error.response && error.response.data) || null
  if (details == null) details = error.body
  const opCodes = get(details, 'extras.result_codes.operations', [])
  const txMessages = get(details, 'extras.result_codes.messages', [])
  if (!opCodes.length) return {}
  if (opCodes.length !== txMessages.length) return { code: opCodes[0], message: txMessages[0] }
  if (opCodes.length === 1) return { code: opCodes[0], message: txMessages[0] }
  return deriveCorrectTxError(opCodes, txMessages)
}

function deriveCorrectTxError (opCodes, txMessages) {
  let correctError = {}
  opCodes.forEach((code, i) => {
    if (code !== 'op_success') {
      correctError.code = code
      correctError.message = txMessages[i]
    }
  })
  return correctError
}



// WEBPACK FOOTER //
// ./src/js/parsers/error.parser.js